import type { ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";

type FootnoteProps = ComponentProps<"small">;

export function Hint({ children, className, ...props }: FootnoteProps) {
  return (
    <small className={cn("tw:block tw:text-sm tw:text-text-tertiary", className)} {...props}>
      {children}
    </small>
  );
}
